import { render, staticRenderFns } from "./kechengzhongxin.vue?vue&type=template&id=5e0821f5&scoped=true"
import script from "./kechengzhongxin.vue?vue&type=script&lang=js"
export * from "./kechengzhongxin.vue?vue&type=script&lang=js"
import style0 from "./kechengzhongxin.vue?vue&type=style&index=0&id=5e0821f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0821f5",
  null
  
)

export default component.exports